import { Card, CardContent, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectTile } from 'src/app/selectors/appDataSelectors';
import { setSelectedReportTile } from 'src/slices/appDataSlice';
import { TileGraph } from '../TileGraph/TileGraph';
import { MenuConfig } from 'src/types/generic';
import { TransactionData, TransactionResponse } from 'src/types/transactions';

const TileView = ({
  keyValue,
  graphData,
  isSelected,
  dataKey,
  tooltip,
  title,
  value,
  config,
}: {
  keyValue: string;
  graphData: TransactionData;
  isSelected: boolean;
  dataKey: string;
  tooltip: string;
  title: string;
  value: string;
  config: MenuConfig;
}) => {
  const dispatch = useDispatch();
  const theme = useTheme(); // Access theme
  let data = value;
  let isData = true;
  if (!data || data == null || data === '0') {
    data = 'No data available with the current selection.';
    isData = false;
  }
  const handleClick = () => {
    localStorage.setItem('selectedReportTile', dataKey);
    localStorage.setItem('selectedReportTileTitle', title);
    dispatch(setSelectedReportTile(dataKey));
  };
  let barData = [];
  if (
    ['prodrevenue', 'prodtransactions'].includes(dataKey) &&
    graphData && graphData.length > 0
  ) {
    barData = graphData[0].data
      .filter((item) => item.value > 0)
      .sort((a, b) => b.value - a.value);
  }
  return (
    <Tooltip title={tooltip}>
      <Card
      key={keyValue}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        maxHeight: '120px',
        boxShadow: isSelected
          ? `0 4px 20px ${theme.palette.primary.main}` // Primary color shadow
          : 'none',
        border: isSelected
          ? `0.5px solid ${theme.palette.primary.main}` // Primary color border
          : 'none',
        //backgroundColor: `${theme.palette.background.default}`
        '& .css-1tola1h-MuiGrid-root > .MuiGrid-item': {
          marginLeft: config.graphType === 'funnel' ? '10px' : '0px',
          paddingTop: config.graphType === 'funnel' ? '15px' : '0px'
        },
        '& .css-1lt5qva-MuiCardContent-root:last-child .label': {
          display: config.graphType === 'funnel' ? 'none !important' : 'flex !important',
        },
        '& .label': {
          display: config.graphType === 'funnel' ? 'none !important' : 'flex !important'
        },
        '& .css-1dekcki-MuiPaper-root-MuiCard-root':{
          boxShadow: config.graphType === 'funnel' ? 'none !important' : '',
        }
      }}
    >
      <CardContent sx={{ padding: '0px', paddingBottom: 0 }}>
       
        
        <Typography >{title}</Typography>
        {config.graphType === 'funnel' ? <></> : <>
        {['prodrevenue', 'prodtransactions'].includes(dataKey) &&
        barData &&
        barData.length > 0 ? (
          <Typography
            style={{
              width: '200px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {barData[0]?.x}
          </Typography>
        ) : (
          <Typography variant={isData ? 'h4' : 'body2'}>{data}</Typography>
        )}
        </>}

        <TileGraph graphData={graphData} config={config} />
      </CardContent>
      </Card>
    </Tooltip>
  );
};

export default TileView;
